<template>
  <van-icon name="replay" size="16" @click="queryOrderCode" />
</template>

<script>
import { getOrderCode } from '@/api/commons'
export default {
  props: {
    type: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      loading: false
    }
  },
  methods: {
    queryOrderCode() {
      this.loading = true
      getOrderCode({
        type: this.type
      }).then(resp => {
        this.loading = false
        this.$emit('getCode', resp.obj || '')
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/base/order-code.vue